<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCog, faRobot } from '@fortawesome/free-solid-svg-icons'
    import { onMount } from 'svelte'
    import { Route, Link, Router, router, navigateTo } from 'yrv'
    import Pipe from './pipe.svelte'
    import { BoardsRepository } from '../../modules/pipelineApi/pipeline/boards/boards.repository'
    import { BoardsService } from '../../modules/pipelineApi/pipeline/boards/boards.service'
    import type { Board as BoardEntity } from '../../modules/pipelineApi/pipeline/boards/board'
    import BoardManager from './manager/board-manager.svelte'
    import AutomacaoManager from '../automacao/automacao-manager.svelte'
    import { AutomationSourceEnum } from '../../modules/automationApi/automations/automation-source.enum'
    import Ztab from '../_common/z/ztab.svelte'

    const boardR = new BoardsRepository()
    const boardS = new BoardsService(boardR)

    let boards: BoardEntity[] = []

    onMount(async () => {
        await loadBoards()
    })

    async function loadBoards() {
        boards = await boardS.getAll()
        console.log('boards', boards)
        if ($router.path === '/pipeline') {
            if (boards.length > 0) {
                const last = await window.flags('pipeline', true)
                const to = '/pipeline/' + (!!last ? last : boards[0].boardId)
                navigateTo(to)
            }
        }
        loadTabs()
    }

    async function boardChange() {
        loadBoards()
    }

    let tabs = []

    function loadTabs() {
        tabs = []
        for (const item of boards) {
            tabs.push({ title: item.label, url: '/pipeline/' + item.boardId })
        }
        tabs.push({ title: 'Configurar', url: '/pipeline/config' })
    }
</script>

<div class="root-content-pipe">
    <Ztab class="h-space" {tabs}></Ztab>
    <Router>
        <Route path="/:id" let:router>
            <Pipe id={router.params.id} />
        </Route>
        <Route path="/config">
            <BoardManager on:change={boardChange} />
        </Route>
    </Router>
</div>

<style>
    .root-content-pipe {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 0px 16px;
    }

    :global(.root-content-pipe .ztab) {
        width: 100%;
    }
</style>
